import { ConfigInterface } from 'swr';
import { api, useApi, parseUrl } from '@gik/core/api';
import { IUserProfileClaim } from '@gik/calendar/models/Claim';

const path = 'claims';

function getParams(userId: string, period: 'upcoming' | 'history') {
  return {
    userId,
    period,
    per_page: 999,
  };
}

export async function getUpcomingClaims(userId: string) {
  const finalUrl = parseUrl(`${path}`, {
    searchParams: getParams(userId, 'upcoming'),
  });
  return (await (await api.get(finalUrl)).json()) as IUserProfileClaim[];
}

export function useUpcomingClaims(userId?: string, config?: ConfigInterface) {
  return useApi<IUserProfileClaim[]>(userId ? `${path}` : null, config, {
    searchParams: getParams(userId, 'upcoming'),
  });
}

export async function getHistoryClaims(userId: string) {
  const finalUrl = parseUrl(`${path}`, {
    searchParams: getParams(userId, 'history'),
  });
  return (await (await api.get(finalUrl)).json()) as IUserProfileClaim[];
}

export function useHistoryClaims(userId?: string, config?: ConfigInterface) {
  return useApi<IUserProfileClaim[]>(userId ? `${path}` : null, config, {
    searchParams: getParams(userId, 'history'),
  });
}
